import { render, staticRenderFns } from "./MidiaVerticalTelaCheia.vue?vue&type=template&id=f021eaf6&scoped=true"
import script from "./MidiaVerticalTelaCheia.vue?vue&type=script&lang=js"
export * from "./MidiaVerticalTelaCheia.vue?vue&type=script&lang=js"
import style0 from "./MidiaVerticalTelaCheia.vue?vue&type=style&index=0&id=f021eaf6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f021eaf6",
  null
  
)

export default component.exports